import { sortEntities } from "./sortEntities.js";
const moveEntity = (entityList, sortByField, oldIndex, newIndex) => {
  moveEntityInArray(Array.from(entityList), entityList.getAccessor, sortByField, oldIndex, newIndex);
};
const moveEntityInArray = (entities, getAccessor, sortByField, oldIndex, newIndex) => {
  const sorted = sortEntities(entities, sortByField);
  const order = computeEntityOrder(sorted, sortByField, oldIndex, newIndex);
  getAccessor().batchUpdates((getAccessor2, { getEntityByKey }) => {
    for (const [entityKey, newOrderValue] of order) {
      const targetEntity = getEntityByKey(entityKey);
      const orderField = targetEntity.getRelativeSingleField(sortByField);
      orderField.updateValue(newOrderValue);
    }
  });
  return sorted;
};
const computeEntityOrder = (entities, sortByField, oldIndex, newIndex) => {
  const order = /* @__PURE__ */ new Map();
  for (let i = 0, len = entities.length; i < len; i++) {
    const entity = entities[i];
    const orderField = entity.getRelativeSingleField(sortByField);
    let targetValue;
    if (i === oldIndex) {
      targetValue = newIndex;
    } else if (newIndex > oldIndex && oldIndex < i && i <= newIndex) {
      targetValue = i - 1;
    } else if (newIndex < oldIndex && newIndex <= i && i < oldIndex) {
      targetValue = i + 1;
    } else {
      targetValue = i;
    }
    if (typeof orderField.value !== "number" || orderField.value !== targetValue) {
      order.set(entity.key, targetValue);
    }
  }
  return order;
};
export {
  moveEntity,
  moveEntityInArray
};
//# sourceMappingURL=moveEntity.js.map
